/**
 * Moderation Total Cases Panel
 *
 * Displays the total number of moderation cases with change indicator
 */

import { Card, Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationTotalCasesPanelProps {
  totalCases: number;
  change?: number;
  isLoading?: boolean;
}

export function ModerationTotalCasesPanel({ totalCases, change, isLoading = false }: ModerationTotalCasesPanelProps) {
  if (isLoading) {
    return (
      <Card elevation="low" padding="medium">
        <div className={styles.panelContent}>
          <div className={styles.header}>
            <span className={styles.title}>TOTAL CASES</span>
          </div>
          <Shimmer className={styles.shimmerValue} label="Loading total cases count" />
        </div>
      </Card>
    );
  }

  return (
    <Card elevation="low" padding="medium">
      <div className={styles.panelContent}>
        <div className={styles.header}>
          <span className={styles.title}>TOTAL CASES</span>
        </div>
        <Text as="div" className={styles.value}>
          {totalCases.toLocaleString()}
        </Text>
        {change !== undefined && (
          <Text as="div" className={styles.subtitle}>
            {change > 0 ? '+' : ''}
            {change} last 24h
          </Text>
        )}
      </div>
    </Card>
  );
}
